import React from 'react';
import Icon from '../../../Base/Components/Icon/Icon';
import { IconType } from '../../../Base/Enums/IconType.enum';
import styles from './PatientBankIdVerifiedBadge.module.scss';
import Text from '../../../../Components/Base/Text/Text';

interface Props {
	verified: boolean;
}

const PatientBankIdVerifiedBadge: React.FC<Props> = ({ verified }) => {
	if (!verified) {
		return <></>;
	}

	return (
		<div className={styles.wrapper}>
			<Text tx='component.patientVerificationBadge.verified' />
			<Icon type={IconType.BANK_ID} className={styles.bankIdIcon} />
		</div>
	);
};

export default PatientBankIdVerifiedBadge;
